import { z } from "zod";

/**
 * Service HTTP auth — API key owned by the tool creator (Nexus/admin).
 * Key is embedded in this record and injected into every request as an HTTP header.
 * No per-org credential lookup — every org using this tool shares the same key.
 *
 * ⚠️ apiKey is sensitive — stored in plaintext in the tool record.
 * Existing architectural decision; encryption is a separate concern.
 */
export const CustomManifestServiceHttpSchema = z.object({
  type: z.literal("service_http"),
  apiKey: z.string().optional(),
  authorization_type: z.enum(["basic", "bearer", "custom"]).optional(),
  custom_header_name: z.string().optional(),
  custom_header_prefix: z.string().optional()
});

export type CustomManifestServiceHttp = z.infer<typeof CustomManifestServiceHttpSchema>;
